import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SponsoredSkyscraperBanner } from '@thd-olt-component-react/sponsored-content';
import { LayoutManager, LayoutGroup } from '@thd-olt-component-react/layout-manager';
import './Column.scss';

const getColumnSize = (opts) => {
  const {
    defaultSize,
    extraSmallSize,
    smallSize,
    mediumSize,
    largeSize,
    extraLargeSize
  } = opts;
  let columnSize = '';
  if (defaultSize) {
    columnSize += `col__${defaultSize}`;
  }
  if (extraSmallSize) {
    columnSize += ` col__${extraSmallSize}--xs`;
  }
  if (smallSize) {
    columnSize += ` col__${smallSize}--sm`;
  }
  if (mediumSize) {
    columnSize += ` col__${mediumSize}--md`;
  }
  if (largeSize) {
    columnSize += ` col__${largeSize}--lg`;
  }
  if (extraLargeSize) {
    columnSize += ` col__${extraLargeSize}--xl`;
  }
  return columnSize;
};

/**
 * @group Layout
 * Displays legacy column component for deprecated content grid
 */

const Column = (props) => {
  const { opts, children, channel, bannerData } = props;
  const { id, name, hideOnMobile } = opts;
  const columnSize = getColumnSize(opts);
  const gridClass = classNames(columnSize);
  const isMobile = channel === 'mobile';
  const isDirectParentOfColumnRail = opts?.content?.[0]?.content?.[0]?.isColumnRail;
  const showBanner = !isMobile && isDirectParentOfColumnRail && bannerData?.isCategory;

  if (isMobile && hideOnMobile) {
    return null;
  }

  return (
    <div
      className={gridClass}
      id={name || id}
    >
      <div className="content">
        {children}
      </div>
      {showBanner && (
        <LayoutManager name="sponsored-skyscraper-banner-wrapper" useContextForProps>
          <LayoutGroup name="sponsored-skyscraper-banner">
            <div className='content column clp-skyscraper-banner'>
              <SponsoredSkyscraperBanner pageContext={{ label: 'browse-search', ...bannerData }} />
            </div>
          </LayoutGroup>
        </LayoutManager>
      )}
    </div>
  );
};

Column.propTypes = {
  children: PropTypes.instanceOf(Object),
  opts: PropTypes.shape({
    id: PropTypes.string,
    isColumnRail: PropTypes.bool,
    name: PropTypes.string
  }).isRequired,
  channel: PropTypes.string
};
Column.defaultProps = {
  children: [],
  channel: 'desktop'
};

export default Column;
